import React from "react";
import "./App.scss";
//import "./assets/css/index.css";
import "./assets/scss/_init.scss";
import "./assets/scss/_fonts.scss";
import "./assets/scss/_bl_hello_content.scss";
import "./assets/scss/home_b_hello.scss";
import "./assets/scss/menu.scss";
import "./assets/scss/style.scss";
import Header from "./components/Header/Header";
import Home from "./components/AlphaHome/Home"
import About from './components/AlphaHome/About'
import Footer from "./components/Footer/Footer"
import SpecificationContainer from "./components/Specification/SpecificationContainer"
import SpecificationTimerRtcc22 from "./components/Specification/SpecificationTimerRtcc22"
import SpecificationTimerUsfr22 from './components/Specification/SpecificationTimerUsfr22'
import ContainerXbcLa from './components/SpecRezonators/ContainerXbcLa'
import ContainerXbcLn from './components/SpecRezonators/ContainerXbcLn'
import Xxx from './components/Xtest/Xxx'
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import GenModelsHelloContainer from "./components/GenModelsHello/GenModelsHelloContainer";

import Modal2 from './components/Modal/Modal2'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'

function App(props) {
  //debugger
  return (
    <BrowserRouter basename="/" >
      <div className="app-wrapper">
        <Header />
        <div className="container mt-3"><Modal2 /></div>
        
        <main className="maincontent">
          <Routes>
            <Route path="/" element={<Home />}  />
            <Route path="/home" element={<Home />}  />
              <Route
              path="/osho_models"
              element={<GenModelsHelloContainer />}
            />
              <Route
              path="/usfr22"
              element={<SpecificationTimerUsfr22 />}
            />            
              <Route
              path="/rtcc22"
              element={<SpecificationTimerRtcc22 />}
            />
            
              <Route
              path="/XbcLa"
              element={<ContainerXbcLa />}
            />
              <Route
              path="/XbcLn"
              element={<ContainerXbcLn />}
            />

            <Route path="/about" element={<About />} />
            <Route path="/specification/:generatorId" element={<SpecificationContainer />} />
            <Route path="/xxx" element={<Xxx />} />
            
            <Route
              path="/*"
              element={<Home />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

//new page

const News = () => {
  return <h2>Here's News</h2>;
};
const Hello = () => {
  return <h2>Here's Helloooo!!!! I'm in processing...</h2>;
};
const NotFound = () => {
  return <h2>Error 404! Not Found Page</h2>;
};
const ComingSoon = () => {
  return <h2>This Page has not ready yet...</h2>;
};
export default App;
